import { render, staticRenderFns } from "./DialogResourceSubWorktimeWeek.vue?vue&type=template&id=5905063a&"
import script from "./DialogResourceSubWorktimeWeek.vue?vue&type=script&lang=js&"
export * from "./DialogResourceSubWorktimeWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports